import { AddContinuouslyUsedMedicineButton } from './AddContinuouslyUsedMedicineButton';
import { DeleteContinuouslyUsedMedicineButton } from './DeleteContinuouslyUsedMedicineButton';

type ContinuouslyUsedMedicineButtonProps = {
   readonly patientId: number;
   readonly medicineId: number;
   readonly medicineValid: boolean | undefined;
   readonly continuouslyUsedMedicineId: number | undefined;
   readonly medicineName: string;
   readonly onMedicineProcessed: VoidFunction;
};

export const ContinuouslyUsedMedicineButton = (props: ContinuouslyUsedMedicineButtonProps): JSX.Element => {
   if (props.continuouslyUsedMedicineId) {
      return (
         <DeleteContinuouslyUsedMedicineButton
            continuouslyUsedMedicineId={props.continuouslyUsedMedicineId}
            onMedicineDeleted={props.onMedicineProcessed}
            medicineName={props.medicineName}
            medicineValid={props.medicineValid}
         />
      );
   }

   return (
      <AddContinuouslyUsedMedicineButton
         medicine={props.medicineId}
         patientId={props.patientId}
         onMedicineAdded={props.onMedicineProcessed}
         disabled={props.medicineValid === false}
      />
   );
};
